import React from "react";
import { useTranslation } from "react-i18next";
import { GoBackButtonStyled } from "./GoBackButton.style";
import GoBackIcon from "./../assets/GoBackIcon";
import { useHistory } from "react-router-dom";

const GoBackButton = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <GoBackButtonStyled onClick={() => history.goBack()}>
      <GoBackIcon width="22px" height="22px" />
      <span className="ms-1"> {t("GENERAL.BACK")}</span>
    </GoBackButtonStyled>
  );
};

export default GoBackButton;
